module.exports = __webpack_public_path__ + "media/bootstrap-icons/sort-alpha-down-alt-89d646d4.svg";